import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class MutuaService {

  private baseUrl = environment.mutuaWSBase + '/Verificacion';

  constructor(private http: HttpClient) {}

  /** Obtiene el token real del Graph / MSAL localStorage */
  private getGraphToken(): string | null {
    try {
      // Buscar el accessToken con permisos de Graph (scope con "profile openid email")
      const tokenKey = Object.keys(localStorage).find(k =>
        k.includes('accesstoken') &&
        k.includes('profile openid email groupmember.read.all mail.read user.read.all')
      );

      if (!tokenKey) {
        console.warn('No se encontró el token Graph en localStorage.');
        return null;
      }

      const item = localStorage.getItem(tokenKey);
      if (!item) return null;

      const parsed = JSON.parse(item);
      const token = parsed.secret;

      if (!token) {
        console.warn('No se encontró "secret" en el token Graph.');
        return null;
      }

      console.log('Token Graph obtenido:', tokenKey);
      return token;
    } catch (err) {
      console.error('Error leyendo token Graph:', err);
      return null;
    }
  }

  /** Llama al endpoint Mutua con el token sin Bearer */
  verificarCobertura(taller: string, matricula: string, fecha: string): Observable<any> {
    
    const urlendpoint = `${this.baseUrl}/verificaciones`;
    
    if (!taller) {
      throw new Error("El código de taller es obligatorio para la verificación.");
    }

    const apiToken = this.getGraphToken();
    if (!apiToken) {
      throw new Error("Token Graph no encontrado o inválido.");
    }

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'taller': taller.trim(),
      'Authorization': `Bearer ${apiToken}` 
    });


    const body = {
      matricula: matricula.trim(),
      fecha: fecha
    };

    return this.http.post<any>(urlendpoint, body, { headers });
  }

  /** Verificamos permisos para mostrar popup o no. */
  verificarPermisoMutuaHub(taller: string): Observable<any> {
    
    if (!taller) {
      throw new Error("El código de taller es obligatorio.");
    }

    const apiToken = this.getGraphToken();
    if (!apiToken) {
      throw new Error("Token Graph no encontrado o inválido.");
    }

    // NO modificamos el taller: ni añadimos ceros, ni quitamos, ni transformamos.
    const tallerParam = encodeURIComponent(taller);

    const url = `${this.baseUrl}/verificar-permiso?taller=${tallerParam}&origen=hub`;

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${apiToken}`,
      'taller': taller.trim(),
      'Content-Type': 'application/json'
    });

    return this.http.get<any>(url, { headers });
  
  }


}
